import { routeHash } from "./helpers.mjs";

export const READY_SOLUTION_ADMIN_TABS = [["solutions", "Решения"], ["agents", "Агенты"], ["models", "Список моделей"]];
export const COUNTERPARTY_ADMIN_SOLUTION_ID = "solution_counterparty_research_v2";

// Administrative slots mirror the workflow declared in code, including the
// optional parallel researcher before it is added to a published solution.
export const COUNTERPARTY_ADMIN_AGENTS = [
  {
    agentId: "counterparty-research-v2",
    label: "1",
    name: "Агент 1 · Исследователь контрагентов",
    description: "Собирает сведения о компании из открытых источников и готовит подробное досье.",
    input: "ИНН юридического лица и цель проверки.",
    output: "Черновое досье и найденные источники в MD и JSON.",
  },
  {
    agentId: "counterparty-research-v2-1-1",
    label: "1.1",
    name: "Агент 1.1 · Исследователь контрагентов",
    description: "Выполняет то же исследование параллельно другой моделью. Результат сохраняется отдельно.",
    input: "Те же ИНН, цель, инструкция и источники, что у Агента 1.",
    output: "Отдельное черновое досье и источники в MD и JSON.",
  },
  {
    agentId: "counterparty-research-v2-2", label: "2", bindingKey: "independentResearcher", role: "researcher_2",
    name: "Агент 2 · Независимый исследователь",
    description: "Дополняет досье собственным веб-поиском, исследует юридические события, долги, связи и расхождения.",
    input: "ИНН, цель проверки и материалы Агентов 1 и 1.1, если он включён.",
    output: "Новые сведения, источники, подтверждения и расхождения в MD и JSON.",
  },
  {
    agentId: "counterparty-research-v2-3", label: "3", bindingKey: "analyst", role: "analyst_3",
    name: "Агент 3 · Аналитик",
    description: "Объединяет материалы исследователей, убирает повторы, сохраняет противоречия и ссылки.",
    input: "Материалы всех участвовавших исследователей.",
    output: "Сводный структурированный черновик справки в MD и JSON.",
  },
  {
    agentId: "counterparty-research-v2-4", label: "4", bindingKey: "factChecker", role: "factchecker_4",
    name: "Агент 4 · Фактчекер",
    description: "Проверяет факты в сводке и сохраняет замечания только по явным, доказуемым ошибкам.",
    input: "Сводка Агента 3, исходные исследования и источники для проверки.",
    output: "Отдельный файл замечаний с подтверждениями и ограничениями проверки в MD и JSON.",
  },
];

export function readySolutionAdminView(tab) {
  return READY_SOLUTION_ADMIN_TABS.some(([id]) => id === tab) ? tab : "solutions";
}

export function readySolutionAdminHref(tab = "solutions", agentId = "") {
  return routeHash("settings", "ready-solutions", { tab, ...(agentId ? { agent: agentId } : {}) });
}

export function readySolutionSettingsHref(solutionId = COUNTERPARTY_ADMIN_SOLUTION_ID) {
  return routeHash("settings", "ready-solutions", { tab: "solutions", solution: solutionId });
}

export function counterpartyAgentBinding(draft, agent) {
  return agent.label === "1" ? draft : draft?.[agent.bindingKey || "parallelResearcher"];
}

export function newParallelResearcher(draft) {
  return { provider: "", model: "", maxOutputTokens: draft.maxOutputTokens, reasoning: draft.reasoning || "", searchProvider: "", searchModel: "" };
}

export function newWorkflowAgent(draft, prompt) {
  return { ...newParallelResearcher(draft), maxOutputTokens: Math.min(draft.maxOutputTokens || 16000, 16000), prompt: prompt || "" };
}
